import { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';
import Logo2020 from 'dibs-icons/exports/Logo2020';
import Logo2020Trade from 'dibs-icons/exports/Logo2020Trade';
import LogoVip from 'dibs-icons/exports/LogoVip';
import styles from './LogoNav-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'home link|1stdibs logo',
};

type Props = {
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
    isNavigationRefreshVariant?: boolean;
    isUsedInHeader?: boolean;
    isStickyLogo?: boolean;
};

const Logo: FC<Props> = ({
    isUserTypeTrade,
    isUserTypeVip,
    isNavigationRefreshVariant,
    isUsedInHeader,
    isStickyLogo,
}) => {
    let LogoComponent = Logo2020;
    if (isUserTypeTrade) {
        LogoComponent = Logo2020Trade;
    } else if (isUserTypeVip) {
        LogoComponent = LogoVip;
    }

    const iconWrapperClassName = classNames(styles.iconWrapper, {
        [styles.navigationRefreshIconWrapper]: isNavigationRefreshVariant && isUsedInHeader,
        [styles.stickyLogo]: isStickyLogo,
    });

    return (
        <div className={styles.wrapper}>
            <Link
                ariaLabel="1stDibs"
                href="/"
                dataTn="rob test"
                className={iconWrapperClassName}
                onClick={event => {
                    trackEvent(trackingObj, event);
                }}
            >
                <LogoComponent />
            </Link>
        </div>
    );
};

type PartialState = {
    header: Props;
};

const mapStateToProps = (state: PartialState): Props => {
    const { isUserTypeTrade, isUserTypeVip, isNavigationRefreshVariant } = state.header;

    return {
        isUserTypeTrade,
        isUserTypeVip,
        isNavigationRefreshVariant,
    };
};

export default connect(mapStateToProps)(Logo);
